/**
 * Created by Michael Lamas on 30.03.2026.
 */

// E-Mail Crypt
// https://jumk.de/nospam/
window.UnCryptMailto = function(s) {
	let n = 0;
	let r = "";
	for (let i = 0; i < s.length; i++) {
		n = s.charCodeAt(i);
		if (n >= 8364) {
			n = 128;
		}
		r += String.fromCharCode(n - 1);
	}
	return r;
};

window.linkTo_UnCryptMailto = function(s) {
	location.href = window.UnCryptMailto(s);
};

window.addEventListener('load', () => {
	gsap.registerPlugin(ScrollTrigger);

	const STEPS = 3;
	const circleEl = document.getElementById('circleEl');
	const stepNumEl = document.getElementById('stepNum');
	const texts = Array.from(document.querySelectorAll('.circle-text'));
	const dots = Array.from(document.querySelectorAll('.circle-dot'));

	// Rotationen: 3 Steps → 0°, 120°, 240°
	// (360° / 3 Steps = 120° pro Step)
	const ROTATIONS = [0, 120, 240];

	let currentStep = 0;

	function goToStep(index) {
		if (index === currentStep && index !== 0) {
			return;
		}
		currentStep = index;

		// 1. Kreis-Rotation
		circleEl.style.setProperty('--arc-rotation', ROTATIONS[index] + 'deg');

		// 2. Step-Nummer im Donut
		stepNumEl.textContent = index + 1;

		// 3. Texte umschalten
		texts.forEach((t, i) => t.classList.toggle('is-active', i === index));

		// 4. Dots
		dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
	}

	if (document.querySelectorAll('#circle').length) {
		// Initial
		goToStep(0);

		// ScrollTrigger: Pin + diskrete Steps

		ScrollTrigger.create({
			trigger: '#circle',
			start: 'top top',
			end: '+=' + (STEPS * 380),   // Scrollstrecke gesamt
			pin: true,
			anticipatePin: 1,
			snap: {
				snapTo: 1 / STEPS,              // exakt auf 0, 1/3, 2/3, 3/3
				duration: {min: 0.15, max: 0.3},
				delay: 0.04,
				directional: true,
				ease: 'power2.inOut'
			},
			onUpdate: (self) => {
				// 0…1 → Step 0,1,2 (letzter Snap 1.0 = Step 2)
				const rawIndex = Math.round(self.progress * (STEPS - 1));
				const stepIndex = Math.min(rawIndex, STEPS - 1);
				goToStep(stepIndex);
			}
		});
	}

	gsap.utils.toArray(".reveal").forEach((el, i) => {
		gsap.fromTo(el,
			{autoAlpha: 0, y: 40},
			{
				autoAlpha: 1,
				y: 0,
				duration: 0.8,
				ease: "power2.out",
				delay: i * 0.1,
				scrollTrigger: {
					trigger: el,
					start: "top 80%",
					toggleActions: "play none none reverse"
				},
			}
		);
	});

	gsap.utils.toArray(".bounce").forEach((button, i) => {
		gsap.fromTo(button,
			{
				y: 0,
				scale: 1
			},
			{
				y: -20,
				scale: 1.05,
				duration: 0.3,
				ease: "power2.out",
				repeat: 5,
				yoyo: true,
				scrollTrigger: {
					trigger: button,
					start: "top 80%",
					toggleActions: "play none none reverse"
				}
			})
	})

	gsap.utils.toArray(".usp .tile").forEach((tile, i) => {
		gsap.fromTo(tile,
			{autoAlpha: 0, y: 30, scale: 0.95},
			{
				autoAlpha: 1,
				y: 0,
				scale: 1,
				duration: 0.3,
				ease: "back.out(1.7)",
				delay: i * 0.15,
				scrollTrigger: {
					trigger: ".usp",
					start: "top 80%",
					toggleActions: "play none none none",
					once: true
				}
			}
		);
	});
});

const dialog = document.getElementsByClassName('nav-dialog')[0];
const burgerBtn = document.getElementsByClassName('hamburger-btn')[0];
const closeBtn = document.getElementById('close-btn');

// Öffnen: Nutzt die native Methode .showModal()
burgerBtn.addEventListener('click', () => {
	dialog.showModal(); // Erzeugt nativ den Focus-Trap und Backdrop!
	burgerBtn.setAttribute('aria-expanded', 'true');
});

// Schließen per Button
closeBtn.addEventListener('click', () => dialog.close());

// Event, wenn der Dialog geschlossen wird (auch durch Esc-Taste)
dialog.addEventListener('close', () => {
	burgerBtn.setAttribute('aria-expanded', 'false');
	burgerBtn.focus(); // Fokus zurück zum Button
});

// accordion.js
document.addEventListener('DOMContentLoaded', () => {
	const buttons = document.querySelectorAll('[aria-controls]');
	const contents = document.querySelectorAll('[id][hidden]');

	buttons.forEach((button) => {
		button.addEventListener('click', () => {
			const id = button.getAttribute('aria-controls');
			const content = document.getElementById(id);
			const isExpanded = button.getAttribute('aria-expanded') === 'true';

			// alle schließen (falls nur ein Item offen sein soll)
			// wenn du mehrere gleichzeitig offen lassen willst, entferne die nächsten 4 Zeilen
			buttons.forEach((b) => {
				const cId = b.getAttribute('aria-controls');
				const c = document.getElementById(cId);
				c?.setAttribute('hidden', '');
				b.setAttribute('aria-expanded', 'false');
			});

			// umschalten
			if (isExpanded) {
				content?.setAttribute('hidden', '');
				button.setAttribute('aria-expanded', 'false');
			}
			else {
				content?.removeAttribute('hidden');
				button.setAttribute('aria-expanded', 'true');
			}
		});
	});

	// optional: beim Laden eines speziellen Ids öffnen, z.B. #acc-nickel
	const hash = window.location.hash;
	if (hash) {
		const targetButton = document.querySelector(`[aria-controls="${hash.slice(1)}"]`);
		if (targetButton) {
			const id = targetButton.getAttribute('aria-controls');
			const content = document.getElementById(id);
			content?.removeAttribute('hidden');
			targetButton.setAttribute('aria-expanded', 'true');
		}
	}
});

// Timeline (Über uns / Historie)
// Setzt beim Scrollen den aktiven Meilenstein: Marker, Linie, mitlaufendes Bild, Jahreszahl und Fortschritt
window.addEventListener('load', () => {
	const timeline = document.querySelector('[data-timeline]');

	if (!timeline || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	const items = Array.from(timeline.querySelectorAll('.timeline-item'));
	const images = Array.from(timeline.querySelectorAll('.timeline-image'));
	const yearEl = timeline.querySelector('[data-timeline-year]');
	const numEl = timeline.querySelector('[data-timeline-num]');
	const barEl = timeline.querySelector('[data-timeline-bar]');

	const startYear = parseInt(timeline.dataset.timelineStart, 10) || 1947;
	const currentYear = new Date().getFullYear();

	// "Heute" oder ungültige Werte zählen als aktuelles Jahr
	const yearOf = (item) => {
		const year = parseInt(item.dataset.year, 10);
		return isNaN(year) ? currentYear : year;
	};

	let activeIndex = -1;

	function setActiveMilestone(index) {
		if (index === activeIndex) {
			return;
		}
		activeIndex = index;

		items.forEach((item, i) => {
			item.classList.toggle('is-done', i < index);
			item.classList.toggle('is-active', i === index);
			item.classList.toggle('is-upcoming', i > index);
		});

		images.forEach((image, i) => image.classList.toggle('is-active', i === index));

		const item = items[index];

		if (yearEl) {
			yearEl.textContent = item.dataset.year;
		}

		if (numEl) {
			numEl.textContent = index + 1;
		}

		if (barEl) {
			const progress = (yearOf(item) - startYear) / Math.max(1, currentYear - startYear);
			barEl.style.width = Math.min(100, Math.max(0, progress * 100)) + '%';
		}
	}

	setActiveMilestone(0);

	// Ein Meilenstein ist aktiv, solange er die Bildschirmmitte kreuzt
	items.forEach((item, i) => {
		ScrollTrigger.create({
			trigger: item,
			start: 'top 55%',
			end: 'bottom 55%',
			onToggle: (self) => {
				if (self.isActive) {
					setActiveMilestone(i);
				}
			}
		});
	});
});
